/* MTL — Collection-card purchase router (v3, 2026-08-20)
 * --------------------------------------------------------------------------
 * Direct products submit normally and add to cart.
 * Standard multi-variant products keep shoppers in the collection by opening
 * Horizon's native option picker.
 * Pre-engraved products use MTL Quick-Pick for finish selection.
 * Only products that require engraving/personalization go to the PDP, because
 * adding them without the required customer input creates an invalid order.
 */
(function () {
  'use strict';
  if (window.__mtlChooseToPdp) return;
  window.__mtlChooseToPdp = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.quick-add__button--choose');
    if (!button || button.getAttribute('type') === 'submit') return;

    var quickAdd = button.closest('quick-add-component');
    var mode = quickAdd && quickAdd.getAttribute('data-mtl-purchase-mode');
    var isPersonalized = mode === 'personalize';

    /* A direct product must never open the option modal. This also protects
       mobile shoppers from stale cached markup that briefly exposes the
       choose button instead of the submit button. */
    if (mode === 'direct') {
      var form = quickAdd.querySelector('form[action*="/cart/add"]');
      var submitButton = form && form.querySelector('button[type="submit"][name="add"]');
      if (form && submitButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.requestSubmit(submitButton);
      }
      return;
    }

    /* Backward-safe fallback while cached collection HTML expires. */
    if (!mode) {
      isPersonalized = /personalize/i.test(button.textContent || '');
    }

    /* Finish and ordinary option products stay in-grid. Their native/custom
       handlers continue normally and add the chosen variant to the cart. */
    if (!isPersonalized) return;

    var card = button.closest('product-card') || button.closest('.product-card');
    if (!card) return;

    var link = card.querySelector('a[href*="/products/"]');
    var url = (button.dataset && button.dataset.productUrl) || (link && link.href) || '';
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = url;
  }, true);
})();
